// A page-wide count of Preact's work (gate D2.1: "during play no Preact render runs per frame"). Preact calls its
// public `options.diffed` hook once for every vnode it has diffed, so any render anywhere on the page, a screen's, the
// HUD's or a component's own state update, moves the count. The HUD's per-frame values write to the DOM directly and
// never move it. Installed once, chaining any hook already there.
import { options } from "preact";

let installed = false;
let diffs = 0;

/** The number of vnodes Preact has diffed on this page since the counter was first asked for. */
export function preactDiffs(): number {
  if (!installed) {
    installed = true;
    const prev = options.diffed;
    options.diffed = (vnode) => {
      diffs++;
      prev?.(vnode);
    };
  }
  return diffs;
}
